import { createGlobalStyle } from 'styled-components';
import { gray } from '../theme/colors';

const GlobalStyles = createGlobalStyle`

body {
  --focusable-offset-color: white;
  --focus-offset: 2px;
  --focus-width: 2px;
}

.focusable {
  transition: box-shadow .15s;
  box-shadow: unset;
}

.focusable:focus {
  outline: none;
  box-shadow: 0 0 0 var(--focus-offset) var(--focusable-offset-color), 0 0 0 calc(var(--focus-width) + var(--focus-offset)) ${gray[600]};
}

.focusable:focus-visible {
  outline: none;
  box-shadow: 0 0 0 var(--focus-offset) var(--focusable-offset-color), 0 0 0 calc(var(--focus-width) + var(--focus-offset)) ${gray[600]};
}

.focusable:focus:not(:focus-visible) {
  outline: none;
  box-shadow: none;
}


`;

export default GlobalStyles;
